import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@util/helpers";

type ArticleDividerProps = {
  /** Flag to determine if it is loading or not. */
  isLoading?: boolean;
};

/** The component that is used to divide articles in infinite scroll. */
const ArticleDivider = ({
  isLoading,
}: ArticleDividerProps): React.ReactElement => {
  return (
    <div
      data-testid="article-divider-component"
      className={cn(
        "relative my-2 text-center",
        "after:absolute after:left-0 after:top-1/2 after:-z-10 after:h-[1px] after:w-full after:bg-gray-175"
      )}
    >
      <div className=" inline-block bg-white px-8 font-poppins text-xs font-medium leading-normal tracking-5% text-gray-750">
        {isLoading ? (
          <div className="text-center">
            <FontAwesomeIcon icon={faSpinner} size="2x" spin />
          </div>
        ) : (
          "Next article"
        )}
      </div>
    </div>
  );
};

export default ArticleDivider;
